import SquareIcon from './SquareIcon';
import SvgIcon from './SvgIcon';

export {
    SvgIcon,
    SquareIcon,
};
